export enum ACCErrors {
  HasNoUUID = "Accounting has no uuid",
}
